import React, {useState,useEffect} from "react";
import { InviteBox , RewardGrid, RewardItem,} from './style'
// import { RewardContent, RewardGrid, RewardItem,} from './style'
import {
  // getMatchInvitation,
  getMatchInvitationReward
} from '@/api/user-new'

import {
  getInvitationRank
} from '@/api/combine'


const Invite = ({activityId, token}) => {
  const [rankInfo, setRankInfo] = useState({
    weekRankList: [],
    seasonRankList: [],
  });

  const [rewardInfo, setReward] = useState({
    weekInvitationReward: {awards:[]},
    seasonInvitationReward: {awards:[]}
  });

  const InvitationRank = async () => {
    const data = await getInvitationRank(activityId);

    setRankInfo(data)
  }
  useEffect( () => {  // 我的邀请
    if(!token) { return; }
    InvitationRank()

  }, [token])

  async function  MatchInvitationReward  ()  {
    const data = await getMatchInvitationReward(activityId);
    
    setReward(data)
  }

  useEffect( () => {  // 我的奖励
    if(!token) { return; }
    MatchInvitationReward()
  }, [token])
 
  return (
    <InviteBox>
      <div className="title-box">
        <div className="title">我邀请的好友最新排名</div>
      </div>
      <div className="message">（邀请奖励以邀请的所有好友排名最高组合为准）</div>

      <div className="table" >
        <div className="table_item table_header">
          <div className="quarter">好友名称</div>
          <div className="quarter">季排名</div>
        </div>  
        <div className="list_box">

          {
            rankInfo.seasonRankList && rankInfo.seasonRankList.length && rankInfo.seasonRankList.length > 0 ? 
             rankInfo.seasonRankList.map(item => {
               return (
                 <div className="table_item">

                   <div className="quarter">{item.invitedUserName}</div>
                   <div className="quarter">{(item.state === 0|| item.rank === 0)? '-': (item.rank>200? '200+': item.rank)}</div>
                   
                 </div>
               )
             })
             :<img className="empty" src={require('@/img/activity50/empty2.png')} alt="市值风云" />
             
           
          }
          
    
        </div>
      </div>

      <div className="table" >
        <div className="table_item table_header">
          <div className="friends">好友名称</div>
          <div className="week">周排名</div>
          <div className="week">周次</div>
        </div>  
        <div className="list_box">
        {
         rankInfo.weekRankList && rankInfo.weekRankList.length && rankInfo.weekRankList.length > 0 ? 
          rankInfo.weekRankList.map(item => {
            return (
              <div className="table_item">
                <div className="friends">{item.invitedUserName || '-'}</div>
                <div className="week">{(item.state === 0|| item.rank === 0)? '-': (item.rank>200? '200+': item.rank)}</div>
                <div className="week">{item.termName || '-'}</div>
                
              </div>
            )
          })
          :<img className="empty" src={require('@/img/activity22/empty2.png')} alt="市值风云" />
          
        } 

          <div className="tips">
            注：“-”代表该好友未参赛，提醒TA去参赛吧
            <br/>
            如何参赛：市值风云APP-行情-组合-组合大赛-报名参赛
          </div>
        </div>
      </div>
      <div className="title-box">
        <div className="title">我的最新邀请奖励预览</div>
      </div>
      <div className="reward_box">
        <RewardGrid>
          <RewardItem className='item'>
                <div className='item_header'>
                  <div className='item_header_title'>周度奖励预览</div>
              
                  <div className='item_header_title_tips'>共计 { rewardInfo.weekInvitationReward ? (rewardInfo.weekInvitationReward.count || 0) : '0'} 人</div>
                  <div className='item_header_title_tips'>当前最高排名：{ rewardInfo.weekInvitationReward ? 
                  (rewardInfo.weekInvitationReward.rank?
                    rewardInfo.weekInvitationReward.rank>200?"200+":rewardInfo.weekInvitationReward.rank
                    :'-'
                    ) : '-'}</div>
                </div>
                <div className='item_body'>
                  {
                    rewardInfo.weekInvitationReward && rewardInfo.weekInvitationReward.awards && rewardInfo.weekInvitationReward.awards.length>0 ? rewardInfo.weekInvitationReward.awards.map((item) => {
                      return <div className='li' >{item.name}</div>
                    }): 
                    <img className="empty-img"  src={require('@/img/activity22/empty.png')} alt="市值风云" />	
                  }
                </div>
            </RewardItem>
            <RewardItem className='item'>
              <div className='item_header'>
                <div className='item_header_title'>季度奖励预览</div>
                <div className='item_header_title_tips'>共计 { rewardInfo.seasonInvitationReward ? (rewardInfo.seasonInvitationReward.count || 0) : '0'}人</div>
                <div className='item_header_title_tips'>当前最高排名：
                {rewardInfo.seasonInvitationReward ?
                  (rewardInfo.seasonInvitationReward.rank?
                    rewardInfo.seasonInvitationReward.rank>200?"200+":rewardInfo.seasonInvitationReward.rank
                    :'-'
                    ): '-'}
                {/* { rewardInfo.seasonInvitationReward ? (rewardInfo.seasonInvitationReward.rank||"-") : '-' } */}
                </div>
              </div>
              <div className='item_body'>
              
                {
                  rewardInfo.seasonInvitationReward && rewardInfo.seasonInvitationReward.awards && rewardInfo.seasonInvitationReward.awards.length>0 ? rewardInfo.seasonInvitationReward.awards.map((item) => {
                    return <div className='li' >{item.name}</div>
                  }): 
                  <img className="empty-img" src={require('@/img/activity22/empty.png')} alt="市值风云" />	
                }
                
              </div>
            </RewardItem>
           
          </RewardGrid>
          </div>
      <div className="title-box">
        <div className="title">领取流程</div>
      </div>
      <img src={require('@/img/activity22/invite.png')} alt="市值风云" />
    </InviteBox>
  )
}

export default Invite;


// WEBPACK FOOTER //
// ./src/views/activity_100/components/invite.js